<template>
  <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
          <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
          <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card class="box">
          <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>
                  <strong> Import Rubrics Marks </strong>
              </v-toolbar-title>
          </v-toolbar>
          <v-row justify="center" align="center">
              <v-btn class="button pt-0 mt-0" @click="single_import=true;multiple_import=false">Single Rubrics Marks Import </v-btn>
              <v-btn class="button pt-0 mt-0" @click="single_import=false;multiple_import=true">Multiple Rubrics Marks Import </v-btn>
          </v-row>
          <span v-if="single_import == true">
              <v-row class="pt-4" justify="center" dense>
                  <v-col cols="12" sm="2">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="aylist" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                  </v-col>
                  <v-col cols="12" sm="2">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete color="#0F2027" dense rounded required v-model="sem" :items="semlist" item-text="sem" item-value="id" label="Semester" outlined persistent-hint hint="Please Select Semester" />
                  </v-col>
                  <v-col cols="12" sm="2">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete
                          color="#0F2027"
                          dense
                          rounded
                          required
                          v-model="standard"
                          :items="standard_list"
                          item-text="standard"
                          item-value="id"
                          label="Standard"
                          @change="getCourseOffering(standard)"
                          outlined
                          persistent-hint
                          hint="Please Select Standard"
                      />
                  </v-col>
                  <v-col cols="12" sm="2">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete
                          color="#0F2027"
                          dense
                          rounded
                          required
                          v-model="subject"
                          :items="subject_list"
                          item-text="course"
                          item-value="id"
                          label="Course"
                          @change="getCourseAssessmentScheme(subject)"
                          outlined
                          persistent-hint
                          hint="Please Select Course"
                      />
                  </v-col>
                  <v-col cols="12" sm="2" v-if="assessmenttypelist.length > 0">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete
                          color="#0F2027"
                          dense
                          rounded
                          required
                          v-model="assessmenttype"
                          :items="assessmenttypelist"
                          item-text="assessmenttype"
                          item-value="id"
                          label="Assessment Type"
                          outlined
                          return-object
                          @change="getAssessmentDetail()"
                          persistent-hint
                          hint="Please Select Assessment Type"
                      />
                  </v-col>
                  <v-col cols="12" sm="2" v-if="rubrics_details_list != ''">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete
                          color="#0F2027"
                          dense
                          rounded
                          required
                          v-model="rubrics_details"
                          :items="rubrics_details_list"
                          item-text="rubric"
                          item-value="id"
                          label="Select Rubric"
                          outlined
                          persistent-hint
                          hint="Please Select Rubric"
                      />
                  </v-col>
              </v-row>
              <v-row justify="center" align="center" v-if="rubrics_details != null">
                  <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
                      <v-file-input placeholder="CSV of Rubric Marks" prepend-icon="mdi-file" label="Course Offering Learner Data" rounded dense flat outlined show-size v-model="file"></v-file-input>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
                      <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/Import_Course_Offering_Learner.csv">
                          <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
                              Download import CSV format
                              <v-icon right dark>mdi-cloud-download</v-icon>
                          </v-btn>
                      </a>
                  </v-col>
              </v-row>

              <v-row justify="center" align="center">
                  <v-btn v-if="file" class="button pt-0 mt-0" @click="submitFile" :loading="output_load">Submit </v-btn>
              </v-row>

              <!-- shiv new code -->
              <v-col cols="12" sm="12" md="12">
                  <template v-if="load == false">
                      <v-simple-table class="mytable">
                          <template v-slot:default>
                              <thead>
                                  <tr>
                                      <th class="text-left">Registration no</th>
                                      <th class="text-left">Standard</th>
                                      <th class="text-left">Division</th>
                                      <th class="text-left">Course Code</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr>
                                      <td>VVEPP00001</td>
                                      <td>Nursery</td>
                                      <td>Sun</td>
                                      <td>I-001</td>
                                  </tr>
                                  <tr>
                                      <td class="mandatory">Mandatory</td>
                                      <td class="mandatory">Mandatory</td>
                                      <td class="mandatory">Mandatory</td>
                                      <td class="mandatory">Mandatory</td>
                                  </tr>
                              </tbody>
                          </template>
                      </v-simple-table>
                  </template>
              </v-col>
              <!-- shiv code end -->
          </span>

          <span v-if="multiple_import == true">
              <v-row class="pt-4" justify="center" dense>
                  <v-col cols="12" sm="2">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="aylist" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                  </v-col>
                  <v-col cols="12" sm="2">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete color="#0F2027" dense rounded required v-model="sem" :items="semlist" item-text="sem" item-value="id" label="Semester" outlined persistent-hint hint="Please Select Semester" />
                  </v-col>
                  <v-col cols="12" sm="2">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete
                          color="#0F2027"
                          dense
                          rounded
                          required
                          v-model="standard"
                          :items="standard_list"
                          item-text="standard"
                          item-value="id"
                          label="Standard"
                          @change="getCourseOffering(standard)"
                          outlined
                          persistent-hint
                          hint="Please Select Standard"
                      />
                  </v-col>
                  <v-col cols="12" sm="2">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete
                          color="#0F2027"
                          dense
                          rounded
                          required
                          v-model="subject"
                          :items="subject_list"
                          item-text="course"
                          item-value="id"
                          label="Course"
                          @change="getCourseAssessmentScheme(subject)"
                          outlined
                          persistent-hint
                          hint="Please Select Course"
                      />
                  </v-col>
                  <v-col cols="12" sm="2" v-if="assessmenttypelist.length > 0">
                      <v-icon color="error">*</v-icon>
                      <v-autocomplete
                          color="#0F2027"
                          dense
                          rounded
                          required
                          v-model="assessmenttype"
                          :items="assessmenttypelist"
                          item-text="assessmenttype"
                          item-value="id"
                          label="Assessment Type"
                          outlined
                          return-object
                          persistent-hint
                          hint="Please Select Assessment Type"
                      />
                  </v-col>
              </v-row>
              <v-row justify="center" align="center" v-if="assessmenttype != null">
                  <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
                      <v-file-input placeholder="CSV of Rubric Marks" prepend-icon="mdi-file" label="Learner Rubrics MArks Data" rounded dense flat outlined show-size v-model="file_multiple"></v-file-input>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
                      <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/Import_Course_Offering_Learner_mutiple.csv">
                          <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
                              Download import CSV format
                              <v-icon right dark>mdi-cloud-download</v-icon>
                          </v-btn>
                      </a>
                  </v-col>
              </v-row>
              <v-row justify="center" align="center">
                  <v-btn v-if="file_multiple" class="button pt-0 mt-0" @click="submitFile_Multiple" :loading="output_load">Submit </v-btn>
              </v-row>
          </span>

          <span v-if="statuslist != ''">
              <v-col cols="12" sm="12" md="12" v-if="statuslist.statuslist[0].faillist != ''">
                  <v-toolbar flat dense class="toolbar">
                      <v-toolbar-title>Failed Students Data</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                  </v-toolbar>
                  <download-excel class="ma-2 no-display" color="primary" dark :data="statuslist.statuslist[0].faillist" :fields="xls_header1" worksheet="Failed Data" name="Failed_Data.xls">
                      <v-btn class="ma-2 no-display" tile outlined color="success">
                          <v-icon left>mdi-file-excel</v-icon> Excel
                          <v-icon right>mdi-download</v-icon>
                      </v-btn>
                  </download-excel>
                  <template>
                      <v-data-table dense :headers="headers1" :items="statuslist.statuslist[0].faillist" sort-by class="elevation-1 mytable" :search="search"></v-data-table>
                  </template>
              </v-col>

              <v-col cols="12" sm="12" md="12" v-if="statuslist.statuslist[0].statuslist != ''">
                  <template>
                      <v-data-table dense :headers="headers" :items="statuslist.statuslist[0].statuslist" sort-by class="elevation-1 mytable" :search="search">
                          <template v-slot:top>
                              <v-toolbar flat dense class="toolbar">
                                  <v-toolbar-title>Success Students Data</v-toolbar-title>
                                  <v-divider class="mx-4" inset vertical></v-divider>
                                  <v-spacer></v-spacer>
                              </v-toolbar>
                              <v-toolbar flat dense color="white" align="center" justify="center">
                                  <download-excel class="ma-2 no-display" color="primary" dark :data="statuslist.statuslist[0].statuslist" :fields="xls_header" worksheet="Success_Data" name="Success_Data.xls">
                                      <v-btn class="ma-2 no-display" tile outlined color="success">
                                          <v-icon left>mdi-file-excel</v-icon> Excel
                                          <v-icon right>mdi-download</v-icon>
                                      </v-btn>
                                  </download-excel>
                              </v-toolbar>
                          </template>
                      </v-data-table>
                  </template>
              </v-col>
          </span>
      </v-card>
  </div>
</template>
<script>
  import axios from "axios";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
      data: () => ({
          load: false,
          loader: false,
          search: "",
          snackbar_msg: "",
          snackbar: false,
          showrow: false,
          color: "",
          aylist: [],
          ay: "",
          semlist: [],
          sem: "",
          standard_list: [],
          standard: "",
          subject_list: [],
          subject: "",
          assessmenttype: "",
          assessmenttypelist: [],
          evaluated_marks: "",
          rubrics_headers: [],
          rubrics_header: "",
          show_rubrics_card: false,
          rubrics: [],
          rubric: "",
          rubrics_details_list: [],
          rubrics_details: null,
          loading3: false,
          file: null,
          file_multiple: null,
          output_load: false,
          statuslist: [],
          single_import: false,
          multiple_import: false,
          xls_header: {
              PRN_No: "grno",
              Status: "status",
              Marks: "marks",
          },
          headers: [
              { text: "PRN No", value: "grno" },
              { text: "Status", value: "status" },
              { text: "Marks", value: "marks" },
          ],
          xls_header1: {
              PRN_No: "grno",
              Status: "status",
              Remark: "remark",
          },
          headers1: [
              { text: "PRN No", value: "grno" },
              { text: "Status", value: "status" },
              { text: "Reason", value: "remark" },
          ],
      }),

      mounted() {
          this.onLoad();
      },
      methods: {
          submitFile() {
              this.load = true;
              this.output_load = true;
              let formData = new FormData();
              formData.append("file", this.file);
              formData.append("sem", this.sem);
              formData.append("ay", this.ay);
              formData.append("course", this.subject);
              formData.append("standard", this.standard);
              formData.append("ass_tye", this.assessmenttype.id);
              formData.append("rubrics_details", this.rubrics_details);
              axios
                  .post("Examination/importEasycheckmarks_Rubric", formData, {
                      headers: {
                          "Content-Type": "multipart/form-data",
                      },
                  })
                  .then((res) => {
                      if (res.data.status == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                      } else {
                          this.statuslist = res.data;
                          this.output_load = false;
                          this.showSnackbar("#4caf50", "Data Imported Successfully..."); // show snackbar on success
                      }
                  })
                  .catch(function () {
                      console.log("FAILURE!!");
                      this.output_load = false;
                  })
                  .finally(() => {
                      this.output_load = false;
                  });
          },
          submitFile_Multiple() {
              this.load = true;
              this.output_load = true;
              let formData = new FormData();
              formData.append("file", this.file_multiple);
              formData.append("sem", this.sem);
              formData.append("ay", this.ay);
              formData.append("course", this.subject);
              formData.append("standard", this.standard);
              formData.append("ass_tye", this.assessmenttype.id);
              axios
                  .post("Examination/importEasycheckmarks_Rubric_mltiple", formData, {
                      headers: {
                          "Content-Type": "multipart/form-data",
                      },
                  })
                  .then((res) => {
                      if (res.data.status == "NO") {
                          this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                      } else {
                          this.statuslist = res.data;
                          this.output_load = false;
                          this.showSnackbar("#4caf50", "Data Imported Successfully..."); // show snackbar on success
                      }
                  })
                  .catch(function () {
                      console.log("FAILURE!!");
                      this.output_load = false;
                  })
                  .finally(() => {
                      this.output_load = false;
                      this.file_multiple = null;
                  });
          },
          getAssessmentDetail() {
              const formData = {
                  course: this.subject,
                  ay: this.ay,
                  sem: this.sem,
                  standard: this.standard,
                  ass_tye: this.assessmenttype,
              };
              axios
                  .post("/Examination/getAssessmentDetail", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.rubrics_details_list = res.data.rubrics_details_list;
                      } else {
                          this.showSnackbar("#b71c1c", "Something went wrong!");
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                      this.showSnackbar("#b71c1c", "Something went wrong!");
                  })
                  .finally(() => {});
          },
          getCourseAssessmentScheme(course) {
              // alert("standard::"+standard)
              const formData = {
                  course: course,
                  ay: this.ay,
                  sem: this.sem,
              };
              axios
                  .post("/Examination/getCourseAssessmentScheme", formData)
                  .then((res) => {
                      if (res.data.flag == "Yes") {
                          this.assessmenttypelist = res.data.assessment_type_list;
                          if (this.assessmenttypelist.length == 0) {
                              this.showSnackbar("#b71c1c", "Course Assessment Scheme Not Found...!");
                              return;
                          }
                          //  this.evaluated_marks=res.data.evaluated_marks
                          this.showrow = true;
                      } else {
                          //   window.console.log(res.data.msg);
                          this.showSnackbar("#b71c1c", "Something went wrong!");
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {});
          },
          getCourseOffering(standard) {
              // alert("standard::"+standard)
              const formData = {
                  standard: standard,
                  ay: this.ay,
                  sem: this.sem,
              };
              axios
                  .post("/Examination/getCourseOfferings", formData)
                  .then((res) => {
                      if (res.data.flag == "Yes") {
                          this.subject_list = res.data.course_list;
                      } else {
                          //   window.console.log(res.data.msg);
                          this.showSnackbar("#b71c1c", "Something went wrong!");
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {});
          },
          onLoad() {
              axios
                  .post("/Examination/getInitialData")
                  .then((res) => {
                      if (res.data.flag == "Yes") {
                          this.aylist = res.data.ay_list;
                          this.semlist = res.data.sem_list;
                          this.standard_list = res.data.standard_list;
                          this.ay = res.data.curreny_ay;
                          //this.ay=res.data.ay_list.current_ay
                      } else {
                          //   window.console.log(res.data.msg);
                          this.showSnackbar("#b71c1c", "Something went wrong!");
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {});
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
      },
  };
</script>
<style scoped>
  .downbtn {
      float: right;
      text-decoration: none !important;
  }

  /* new css */
  table,
  th {
      padding: 10px;
      border: 1px solid black;
      border-collapse: collapse;
      background: #0f2027; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
      background-color: #0f2027 !important;
      color: white !important;
      font-weight: bold !important;
      white-space: nowrap !important;
      text-align: center;
  }
  .mandatory {
      color: red;
  }
</style>
